import { render } from "./BaseCircleLoader.vue?vue&type=template&id=19aab63a&scoped=true"
import script from "./BaseCircleLoader.vue?vue&type=script&lang=js"
export * from "./BaseCircleLoader.vue?vue&type=script&lang=js"

import "./BaseCircleLoader.vue?vue&type=style&index=0&id=19aab63a&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19aab63a"]])

export default __exports__